import { Breadcrumb, Layout, Menu, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, Route, useLocation, useRouteMatch } from "react-router-dom";

import '../static/css/AdminIndex.css';
import AddCamera from './AddCamera';
import CameraList from './CameraList';
import CarPoolingList from './CarPoolingList';
import EditCamera from './EditCamera';
import FeedbackList from './FeedbackList';
import IdleList from './IdleList';
import MinprogramInfo from './MinprogramInfo';
import AddNotice from './Notice/AddNotice';
import NoticeList from './Notice/NoticeList';
import UserList from './UserList';
// 广告模块
import AdList from './AdList';

import AddAd from './AddAd';
//banner模块
import BannerList from './BannerList';
import AddBanner from './AddBanner';

// 文章模块
import AddNews from './AddNews';
import NewsList from './NewsList';

// 浪点地理分类
import SurfSpotGeoList from './SurfSpotGeoList';
import AddSurfSpotGeo from './AddSurfSpotGeo';

const { confirm } = Modal;

const { Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;


function AdminIndex(props) {
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(false)

  const onCollapse = collapsed => {
    setCollapsed(collapsed)
  };
  const onshow = () => {
    // console.log('当前路径:', location.pathname);
    var token = window.localStorage.getItem("token")
    if (!token) {
      // props.history.push('/login')
    }
  };
  useEffect(() => {

    onshow()
  }, [])
  const loginOut = e => {
    // alert("loginOut")
    confirm({
      title: 'Do you Want to delete these items?',
      // icon: <ExclamationCircleOutlined />,
      content: 'Some descriptions',
      onOk() {
        localStorage.removeItem("token");
        props.history.push('/login')
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  const handleClickArticle = e => {
    // if (e.key === '/ad/addAd' || e.key === '/ad/list') {
    //   setCollapsed(false); // 手动展开折叠
    // }
    // if (e.key === '/surfspotgeo/add' || e.key === '/surfspotgeo/list') {
    //   setCollapsed(false); // 手动展开折叠
    // }
  }

  // 根据当前路由设置选中的菜单项
  const getMenuSelectedKeys = () => {
    const path = location.pathname;
    if (path === '/index/list') {
      return ['/index/list'];
    } else if (path === '/index/addCamera') {
      return ['/index/addCamera'];
    } else if (path === '/ad/addAd') {
      return ['/ad/addAd'];
    } else if (path === '/ad/list') {
      return ['/ad/list'];
    } else if (path === '/surfspotgeo/add') {
      return ['/surfspotgeo/add'];
    } else if (path === '/surfspotgeo/list') {
      return ['/surfspotgeo/list'];
    } else {
      return [];
    }
  };



  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
        <div className="logo" style={{ 'textAlign': 'center', 'lineHeight': '32px', color: '#fff', 'fontZize': '18px' }} >
          Inforsurf System
        </div>
        <Menu theme="dark" defaultSelectedKeys={getMenuSelectedKeys()} mode="inline">
          <Menu.Item key="/index/list">
            {/* <Icon type="pie-chart" /> */}
            <Link to="/index/list">摄像头列表</Link>
          </Menu.Item>
          <Menu.Item key="/index/addCamera" >
            <Link to="/index/addCamera">添加摄像头</Link>
          </Menu.Item>

        <SubMenu
          key="sub4"
          onClick={handleClickArticle}
          title={<span>Banner管理</span>}
        >
          <Menu.Item key="/banner/addBanner">
            <Link to="/banner/addBanner">添加Banner</Link>
          </Menu.Item>
          <Menu.Item key="/banner/list">
            <Link to="/banner/list">Banner列表</Link>
          </Menu.Item>
        </SubMenu>
          <SubMenu
            key="sub1"
            onClick={handleClickArticle}
            title={
              <span>
                <span>广告管理</span>
              </span>
            }
          >
            <Menu.Item key="/ad/addAd">
              <Link to="/ad/addAd">添加广告内容</Link>
            </Menu.Item>
            <Menu.Item key="/ad/list">
              <Link to="/ad/list">广告列表</Link>
            </Menu.Item>
          </SubMenu>

          <SubMenu
            key="sub2"
            onClick={handleClickArticle}
            title={
              <span>
                <span>公告管理</span>
              </span>
            }
          >
            <Menu.Item key="/notice/addNotice">
              <Link to="/notice/addNotice">添加公告内容</Link>
            </Menu.Item>
            <Menu.Item key="/notice/list">
              <Link to="/notice/list">公告列表</Link>
            </Menu.Item>
          </SubMenu>
          <SubMenu
            key="sub3"
            onClick={handleClickArticle}
            title={
              <span>
                <span>知识天地/文章管理</span>
              </span>
            }
          >
            <Menu.Item key="/news/addNews">
              <Link to="/news/addNews">添加文章内容</Link>
            </Menu.Item>
            <Menu.Item key="/news/list">
              <Link to="/news/list">文章列表</Link>
            </Menu.Item>
          </SubMenu>
          <Menu.Item key="/index/idleList" >
            <Link to="/index/idleList">闲置商品列表</Link>
          </Menu.Item>
          <Menu.Item key="/index/carPoolingList" >
            <Link to="/index/carPoolingList">拼车数据列表</Link>
          </Menu.Item>
          <Menu.Item key="/index/userList" >
            <Link to="/index/userList">小程序用户列表</Link>
          </Menu.Item>
          <Menu.Item key="/index/feedbackList" >
            <Link to="/index/feedbackList">反馈意见列表</Link>
          </Menu.Item>
          <Menu.Item key="/index/minprogramInfo" >
            <Link to="/index/minprogramInfo">小程序信息管理</Link>
          </Menu.Item>
          
          {/*
          <SubMenu
            key="sub5"
            onClick={handleClickArticle}
            title={
              <span>
                <span>浪点地理分类</span>
              </span>
            }
          >
            <Menu.Item key="/surfspotgeo/add">
              <Link to="/surfspotgeo/add">添加浪点地理</Link>
            </Menu.Item>
            <Menu.Item key="/surfspotgeo/list">
              <Link to="/surfspotgeo/list">浪点地理列表</Link>
            </Menu.Item>
          </SubMenu>
          */ }
        </Menu>
      </Sider>
      <Layout>
        <Content style={{ margin: '0 16px' }}>
          <Breadcrumb style={{ margin: '16px 0' }}>
            <Breadcrumb.Item>
              {/* 后台管理 */}
            </Breadcrumb.Item>
            <Breadcrumb.Item>工作台</Breadcrumb.Item>
            <div onClick={() => { loginOut() }} style={{ float: 'right', padding: '0 10px', cursor: 'pointer' }}>退出登录</div>
          </Breadcrumb>
          <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
            {/* 博客工作台. */}
            <div>
              <Route path="/" exact component={CameraList} />
              <Route path="/index/AddCamera" component={AddCamera} />
              <Route path="/index/EditCamera/:id" component={EditCamera} />
              <Route path="/index/list/" component={CameraList} />

              {/* banner管理模块 */}
              <Route path="/banner/list" exact component={BannerList} />
              <Route path="/banner/addbanner" exact component={AddBanner} />
              <Route path="/banner/editBanner/:id" exact component={AddBanner} />
              
              {/* ad广告模块 */}
              <Route path="/ad/list/" component={AdList} />
              <Route path="/ad/AddAd" component={AddAd} />
              <Route path="/ad/editAd/:id" component={AddAd} />
              {/* news 文章模块 */}
              <Route path="/news/list/" component={NewsList} />
              <Route path="/news/addNews" component={AddNews} />
              <Route path="/news/editNews/:id" component={AddNews} />
              {/* Notice 公告模块 */}
              <Route path="/notice/list/" component={NoticeList} />
              <Route path="/notice/AddNotice" component={AddNotice} />
              <Route path="/notice/editNotice/:id" component={AddNotice} />

              {/* 反馈内容列表 */}
              <Route path="/index/idleList" component={IdleList} />
              <Route path="/index/carPoolingList" component={CarPoolingList} />
              <Route path="/index/userList" component={UserList} />
              <Route path="/index/feedbackList" component={FeedbackList} />

              {/* 小程序管理 */}
              <Route path="/index/minprogramInfo" component={MinprogramInfo} />
              
              {/* 浪点地理分类 */}
              {/*
              <Route path="/surfspotgeo/list" exact component={SurfSpotGeoList} />
              <Route path="/surfspotgeo/add" exact component={AddSurfSpotGeo} />
              <Route path="/surfspotgeo/edit/:id" exact component={AddSurfSpotGeo} />
              */ }

            </div>
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>Inforsurf System</Footer>
      </Layout>
    </Layout>
  )
}

export default AdminIndex



// ... 在Route组件中添加以下路由
